import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { getWhatsAppLink } from "@/lib/whatsapp";

const MESSAGE =
  "Hola, quiero coordinar la sesión para avanzar con la propuesta de marca personal.";

const ChiappellaCTA = () => {
  const whatsappUrl = getWhatsAppLink(MESSAGE);

  return (
    <section
      id="cta-final"
      className="py-28 md:py-40 relative overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(215 48% 20%), hsl(220 69% 2%))",
      }}
    >
      {/* Radial overlay */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(91,163,224,0.22) 0%, rgba(29,74,140,0.08) 40%, transparent 75%)",
        }}
        aria-hidden="true"
      />

      <div className="relative z-10 container px-4 max-w-4xl mx-auto text-center">
        {/* Eyebrow */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-xs md:text-sm font-semibold tracking-[0.35em] uppercase mb-8 text-white/70"
        >
          El próximo paso
        </motion.p>

        {/* Title */}
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.1 }}
          className="font-display text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-[1.05] mb-8"
        >
          La única decisión
          <br />
          que se toma hoy
          <br />
          <span style={{ color: "#5BA3E0" }}>
            es si querés ocupar ese lugar antes que otro.
          </span>
        </motion.h2>

        {/* Subtitle */}
        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.25 }}
          className="text-base md:text-lg text-white/75 max-w-2xl mx-auto leading-relaxed mb-10"
        >
          Si avanzamos, coordinamos la reunión de arranque con vos y con Tamara,
          y el proyecto se pone en marcha dentro de los cinco días hábiles.
        </motion.p>

        {/* Pull quote */}
        <motion.blockquote
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7, delay: 0.35 }}
          className="font-display italic text-xl md:text-3xl leading-snug mb-12"
          style={{ color: "#5BA3E0" }}
        >
          “Primero el ser. Después la marca. Siempre en coherencia.”
        </motion.blockquote>

        {/* CTA Button */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.45 }}
        >
          <a
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="group inline-flex items-center gap-3 px-10 py-5 md:px-12 md:py-6 rounded-full text-base md:text-lg font-semibold text-white transition-all duration-300 hover:scale-[1.02]"
            style={{
              background: "linear-gradient(135deg, #1d4a8c 0%, #3B8BD4 100%)",
              boxShadow: "0 18px 50px -12px rgba(59,139,212,0.6)",
            }}
          >
            Coordinar la sesión
            <ArrowRight className="w-5 h-5 md:w-6 md:h-6 transition-transform group-hover:translate-x-1" />
          </a>
        </motion.div>

        {/* Footnote */}
        <motion.p
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.6 }}
          className="text-sm md:text-base text-white/60 mt-8 leading-relaxed"
        >
          Propuesta con validez de 7 días hábiles.
        </motion.p>
      </div>
    </section>
  );
};

export default ChiappellaCTA;
